import { createSingleEntityStore } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';
import {
  OfferContentGeneratorRequest,
  OfferContentGeneratorResponse,
} from './offer-content-generator.types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OfferContentGeneratorResponse>()(EntityStoreKey.OfferContentGenerator, {
    customActions: adapter => ({
      fetch: (state, payload: OfferContentGeneratorRequest) => adapter.markAsPending(state),
    }),
  });

export {
  actions as OfferContentGeneratorActions,
  selectors as OfferContentGeneratorSelectors,
  reducer as OfferContentGeneratorReducer,
  namespace as OfferContentGeneratorNamespace,
};
